<script lang="ts">
import { onDestroy, onMount } from 'svelte'
import { scale } from 'svelte/transition'
import UploadIcon from 'virtual:icons/lucide/upload-cloud'

import { dragAndDrop } from '@/modules/app'
import { checkAndAddFiles } from '@/modules/fileUpload/store'
import { t } from '@/modules/translations'
import { getHostWindow } from '@/utils/window'

const handleDrop = (e: DragEvent) => {
	const { droppedFiles } = dragAndDrop.handleDrop(e)
	checkAndAddFiles(droppedFiles)
}
const handleDragOver = (e: DragEvent) => dragAndDrop.handleDragOver(e, false)

onMount(() => {
	getHostWindow().addEventListener('dragover', handleDragOver)
})

onDestroy(() => {
	getHostWindow().removeEventListener('dragover', handleDragOver)
})
</script>

{#if $dragAndDrop}
	<div class="flex-grow p-4" role="form" ondragover={dragAndDrop.handleDragOver} ondrop={handleDrop}>
		<div
			in:scale={{ duration: 200 }}
			class="relative flex w-full h-full rounded-md border-primary border-dashed border-2 items-center"
		>
			<div class="flex flex-col items-center m-auto text-slate-400 text-lg">
				<UploadIcon width="2em" height="2em" />
				<span class="whitespace-nowrap">{$t('dragAndDrop.dropHere')}</span>
			</div>
		</div>
	</div>
{/if}
